<template>
  <v-ons-page class="l-content l-projet">
    <custom-toolbar backLabel="Retour">{{ $t("Mon projet") }}</custom-toolbar>

    <div v-if="project != null">
      <div class="projetPicture" :style="{ backgroundImage: 'url(' + project_background + ')' }"></div>

      <div class="projetInfos">
        <div class="infoContent">
          <div class="container">
            <h2>{{ projectType(project) }} : {{ project.type }}, {{ project.ref }} ({{ project.promoteur }})</h2>
          </div>
        </div>

        <div class="container">
          <div class="grid">
            <div v-for="(image, key) in project.pictures" class="picture" @click="toggleGallery(true, key)" :key="key" :style="{ backgroundImage: 'url(' + project_pictures_url + '/preview/' + image.filename + ')' }"></div>
          </div>
        </div>
      </div>

      <v-ons-modal :visible="galleryVisible" style="max-width: 100%;" class="l-modal gallery">
        <i class="fa fa-times close_btn" @click="galleryVisible = false"></i>
        <v-ons-carousel fullscreen swipeable auto-scroll overscrollable :index.sync="galleryIndex">
          <v-ons-carousel-item v-for="(image, key) in project.pictures" :key="key">
            <div class="carousel-item-wrapper">
              <img :src="project_pictures_url + '/' + image.filename">
            </div>
          </v-ons-carousel-item>
        </v-ons-carousel>
      </v-ons-modal>
    </div>

    <div v-if="project == null">
      {{ $t("Aucun projet pour l'instant") }}
    </div>
  </v-ons-page>
</template>

<script>
  export default {
    data () {
      return {
        user: loggedIn,
        galleryVisible: false,
        galleryIndex: 0,
        project: null,
        project_background: null,
        project_pictures_url: null
      };
    },
    methods: {
      toggleGallery(visible, index = 0) {
        this.galleryVisible = visible;
        this.galleryIndex = index;
      },
      projectType(project) {
        if(typeof project.bien_typeFR == 'string') {
          if(this.$i18n.locale == 'nl' && project.bien_typeNL) {
            return project.bien_typeNL;
          }
        }
        return project.bien_typeFR;
      }
    },
    created() {
      this.project = this.user.project;
      if(this.project) {
        this.project_pictures_url = url_erp + '/biens/' + this.project.bien_id;
        this.project_background = this.project_pictures_url + '/' + this.project.pictures[0].filename;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// Project.vue?23e7d916